import { Component, HostListener, OnDestroy, OnInit } from '@angular/core'
import { AuthService } from './core/services/auth.service'
import { DemoService } from './core/services/demo.service'
import { CanaryService } from './core/services/canary.service'
import { Subject, takeUntil } from 'rxjs'
import { ThemeService } from './shared/services/theme.service'
import { MaintenanceNoticeService } from './core/services/maintenance-notice.service'
import { MapService } from './core/services/map.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: {
    '[class.-dark-mode]': 'theme === "dark"',
    '[class.-light-mode]': 'theme === "light"',
  },
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'RCS-Maps'
  isCanaryEnabled = false
  maintenanceNotice = ''
  theme = 'light'
  private destroy$ = new Subject<void>()

  constructor(
    private authService: AuthService,
    private demoService: DemoService,
    private canaryService: CanaryService,
    private themeService: ThemeService,
    private maintenanceNoticeService: MaintenanceNoticeService,
    private mapService: MapService,
  ) {
    authService.InitializeMsal()
  }

  ngOnInit(): void {
    this.canaryService.isCanaryEnabled$.pipe(takeUntil(this.destroy$)).subscribe((enabled) => {
      this.isCanaryEnabled = enabled
    })

    this.maintenanceNoticeService.notice$.pipe(takeUntil(this.destroy$)).subscribe((notice) => {
      this.maintenanceNotice = notice
      this.resizeMapAfterLayoutChange()
    })

    this.themeService
      .getTheme$()
      .pipe(takeUntil(this.destroy$))
      .subscribe((theme) => {
        this.theme = theme
      })
  }

  ngOnDestroy(): void {
    this.destroy$.next()
    this.destroy$.complete()
  }

  dismissMaintenanceNotice(): void {
    this.maintenanceNotice = ''
    this.resizeMapAfterLayoutChange()
  }

  private resizeMapAfterLayoutChange(): void {
    requestAnimationFrame(() => this.mapService.map?.resize())
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    // Ctrl+Shift+S
    if (event.ctrlKey && event.shiftKey && event.key === 'B') {
      event.preventDefault()
      this.canaryService.toggleCanary()
    }
  }
}
